import { gql } from "lib/apolloClient";

export const getGradeEntityProgressReportTaskDetailsQuery = gql`
  query getGradeEntityProgressReportTaskDetails($id: ID!, $searchText: String) {
    node(id: $id, type: PROGRESS_REPORT_TASK_GROUP) {
      id
      ... on ProgressReportTaskGroup {
        id
        title
        subtitle
        attendanceMode
        academicTerm {
          id
        }
        academicYearId
        template {
          id
          version
          gradingPeriodType
        }
        courseProgressReportTasks(searchText: $searchText) {
          id
          title
          gradeSubjectObjectivesIsComplete
          studentProgressReport {
            id
            status
            student {
              id
            }
          }
          course {
            id
            title
            isArchived
            grades {
              id
            }
          }
          parentEntity {
            id
            ... on Grade {
              id
              name
            }
          }
          filteredNodes
          deadlineDate
          progressReportTaskGroup {
            id
            attendanceMode
            academicTerm {
              id
              label
            }
            academicTerms {
              id
              label
            }
          }
          attendanceDates {
            startDate
            endDate
          }
          reportingDates {
            startDate
            endDate
          }
          reportStatusCount {
            status
            count
          }
          createdAt
        }
      }
    }
  }
`;
